import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useForm } from '../hooks/useForm';
import loginImage from '../assets/cc-login.png';
import signinButton from '../assets/signin-button.png';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const reason = new URLSearchParams(location.search).get('reason');
  const { values, errors, loading, handleChange, handleSubmit } = useForm({
    email: '',
    password: ''
  });

  const onSubmit = handleSubmit(async (formValues) => {
    await login(formValues.email, formValues.password);
    navigate('/policy-checker', { replace: true });
  });

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src={loginImage} alt="Policy Central" className="login-header-image" />
        </div>

        <form className="login-form" onSubmit={onSubmit}>
          {reason === 'session_timeout' && (
            <div className="alert alert-warning" role="alert">
              Your session expired due to inactivity. Please sign in again.
            </div>
          )}
          {reason === 'session_expired' && (
            <div className="alert alert-warning" role="alert">
              Your session has expired. Please sign in again.
            </div>
          )}
          {errors.general && (
            <div className="alert alert-danger" role="alert">
              {errors.general}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email address</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              value={values.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              value={values.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
            <div className="forgot-password-link">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
          </div>

          <button
            type="submit"
            className="btn-signin"
            disabled={loading}
          >
            <img src={signinButton} alt={loading ? 'Signing In...' : 'Sign In'} />
          </button>
        </form>
      </div>
    </div>
  );
}
